import { useContext } from 'react'
import { IProviderProfileContext, UserContextRoot } from './index'
import { BaseUserModel } from './typing'

const useUser = <T extends BaseUserModel>(): IProviderProfileContext<T> =>
  //@ts-ignore
  useContext<IProviderProfileContext<T>>(UserContextRoot)

export default useUser
